import axios from "axios";

export const descargarDatos = (programa = "PR", proceso = 1) => {
  
    const promise = axios.get(`${process.env.REACT_APP_PROD}/api/${programa}/Cortes/${proceso}`);
    const dataPromise = promise.then((res) => 
        res.data)
    return dataPromise;

}
